<template>
    <v-app v-resize="onResize">
        <header>
            <slot name="header"></slot>
        </header>

        <v-main>
            <v-container fill-height>
                <slot name="main"></slot>
            </v-container>
        </v-main>

        <v-footer app>
            <slot name="footer"></slot>
        </v-footer>
    </v-app>
</template>

<script>
import { mapMutations } from 'vuex';
import rootActions from '../store/actions/root';

export default {
	name: 'Layout',
	data() {
		return {
			rtime: null,
			timeout: false,
			delta: 200,
		};
	},
	methods: {
		...mapMutations([rootActions.SET_WINDOW_SIZE]),
		onResize() {
			this.rtime = new Date();
			if (this.timeout === false) {
				this.timeout = true;
				setTimeout(this.resizeend, this.delta);
			}
		},
		resizeend() {
			if (new Date() - this.rtime < this.delta) {
				setTimeout(this.resizeend, this.delta);
			} else {
				this.timeout = false;
				this.SET_WINDOW_SIZE({ x: window.innerWidth, y: window.innerHeight });
			}
		},
	},
};
</script>
